import { PropTypes } from 'prop-types'

ShopBanner.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
}

export default function ShopBanner({ title, url, image }) {
  return (
    <div className='shop-banner-wrapper checkout-wrapper  hidden-xs hidden-sm'>
      <div className='shop-banner'>
        <div className='img' style={{
          backgroundImage: `url(${image})`,
        }} />
        <div className='shop-info'>
          <div className='text-wrapper'>
            <h1>
              <a href={url}>{title}</a>
            </h1>
          </div>
        </div>
      </div>
    </div>)
}
